import { render } from "./CrudIdiomas.vue?vue&type=template&id=21f36740"
import script from "./CrudIdiomas.vue?vue&type=script&lang=js"
export * from "./CrudIdiomas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__